module.exports = __webpack_public_path__ + "1d1d81d8cb323ee9e6448b85eb333c9f.png";